import React, {FC, useState} from "react";
import {NavMenuProps} from "./NavMenuProps";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {GetModules} from "../../silos/new/components/appmodulemgr/AppModuleMgr";
import * as CoreActions from "../../core/store/core-actions";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {menuContainerStyle, moduleDisabledStyle, moduleEnabledStyle} from "./ModuleNavMenu_styles";
import {ApplicationState} from "../../core/types";

export const ModuleNavMenu: FC<NavMenuProps> = () => {
    const dispatch = useDispatch()
    const history = useHistory();
    const isNewUIEnabled = useSelector<ApplicationState, boolean>(state => state.dev.isNewUIEnabled)
    const modules = GetModules(isNewUIEnabled);
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    const select = (route: string, e?: React.MouseEvent) => {
        e?.preventDefault();
        e?.stopPropagation();

        dispatch(CoreActions.setCurrentPageName(route));
        setIsOpen(false);
        history.push(route);
    };

    return (
        <Dropdown nav inNavbar className="module-nav-menu" isOpen={isOpen} toggle={toggle}>
            <div style={menuContainerStyle}>
                <DropdownToggle nav caret role="button" id="moduleDropdown">
                    Select module&nbsp;
                </DropdownToggle>
            </div>

            <DropdownMenu aria-labelledby="moduleDropdown">
                {modules.map((module, index) =>
                    module.enabled ? (
                        <DropdownItem
                            onDragStart={(e) => e.preventDefault()}
                            key={`module_item_${index}`}
                            tag="a"
                            href={module.route}
                            onClick={(e) => select(module.route, e)}
                            style={moduleEnabledStyle}
                        >
                            {module.title}
                        </DropdownItem>
                    ) : (
                        <DropdownItem
                            onDragStart={(e) => e.preventDefault()}
                            key={`module_item_${index}`}
                            disabled
                            style={moduleDisabledStyle}
                        >
                            {module.title}
                        </DropdownItem>
                    )
                )}
            </DropdownMenu>
        </Dropdown>
    )
}
